
import Vue from 'vue';
import { Link } from '@descomplica/vue-components';

export default Vue.extend({
  components: { Link },
  methods: {
    toggleModal(): void {
      this.$emit('soonModal');
    },
  },
});
